import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="garantia" className="w-full bg-cream" data-id="element-42" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 py-16 lg:grid-cols-[0.75fr_1fr] lg:gap-16 lg:px-10 lg:py-24" data-id="element-43" data-mp="1o5zsw7kn0l79">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/181b0736-975f-4d0c-93ae-0e05643fb3aa.jpg" alt="Novia tranquila revisando su checklist impreso antes de la boda" className="aspect-[4/5] w-full rounded-[1.5rem] object-cover" loading="lazy" data-id="element-44" data-mp="1x421p9am4i53" />
        <div data-id="element-45" data-mp="1j5c3trfyyefo">
          <ShieldCheckIcon aria-hidden="true" className="h-8 w-8 text-wine" data-id="element-46" data-mp="1j65181t1frl5" />
          <h2 id="garantia" className="mt-5 font-display text-3xl font-semibold leading-tight text-ink sm:text-[2.6rem]" data-id="element-47" data-mp="1ecspgs9gjf9t">
            Garantía de “Invitados Felices” de 7 días
          </h2>
          <p className="mt-6 max-w-prose font-sans text-lg leading-relaxed text-muted" data-id="element-48" data-mp="lowkz1dncj2h">
            Estamos tan seguros de que este pack te quitará un peso de encima que, si al abrir los
            archivos sientes que no es para ti, te devolvemos el 100% de tu dinero. Sin preguntas.
          </p>
          <p className="mt-6 font-display text-2xl italic text-wine sm:text-3xl" data-id="element-49" data-mp="yq4iovtnfnjo">
            El riesgo es todo nuestro.
          </p>
        </div>
      </div>
    </section>;
}